<template>
    <div class="">
        <!-- <h2 class="main-title mb-3">Stages</h2> -->
        <div class="row g-3">
            <div class="col-md-4">
                  <ol class="breadcrumb fs-sm mb-1">
                    <li class="breadcrumb-item"><router-link to="/dashboard">Dashboard</router-link></li>
                    <li class="breadcrumb-item active"><router-link to="/stages">Stages</router-link></li>
                </ol>
                 <div class="d-flex align-items-center justify-content-between">
                    <label class="form-label">
                        <h4 v-if="status">New Stage</h4>
                        <h4 v-else>Update Stage</h4>
                    </label>
                </div>
                <form @submit.prevent="submitForm()">
                    <div class="card br-16 card-shadow">
                        <div class="card-body mb-3">
                            <div class="row g-3">
                                <div class="col-sm-12">
                                    <label class="form-label">Stage</label><span class="text-danger"> *</span>
                                    <input type="text" placeholder="Stage" class="form-control" :class="{'is-invalid': errors.stage}" v-model="stage.stage" ref="stage" />
                                    <span v-if="errors.stage" class="invalid-feedback">{{ errors.stage}}</span>
                                </div>
                                <div class="col-sm-12">
                                    <label class="form-label">Admin Dashboard Visibility</label><span class="text-danger"> *</span>
                                    <!-- <input type="text" placeholder="Stage" class="form-control" :class="{'is-invalid': errors.stage}" v-model="stage.stage" ref="stage" /> -->
                                    <select class="form-control" :class="{'is-invalid': errors.admin_dashboard_visibility}" v-model="stage.admin_dashboard_visibility">
                                        <option value="">Please select</option>
                                        <option value="true">Yes</option>
                                        <option value="false">No</option>
                                    </select>
                                    <span v-if="errors.admin_dashboard_visibility" class="invalid-feedback">{{ errors.admin_dashboard_visibility}}</span>
                                </div>
                                <div class="col-sm-12">
                                    <label class="form-label">Mobile Dashboard Visibility</label><span class="text-danger"> *</span>
                                    <!-- <input type="text" placeholder="Stage" class="form-control" :class="{'is-invalid': errors.stage}" v-model="stage.stage" ref="stage" /> -->
                                    <select class="form-control" :class="{'is-invalid': errors.dashboard_visibility}" v-model="stage.dashboard_visibility">
                                        <option value="">Please select</option>
                                        <option value="true">Yes</option>
                                        <option value="false">No</option>
                                    </select>
                                    <span v-if="errors.dashboard_visibility" class="invalid-feedback">{{ errors.dashboard_visibility}}</span>
                                </div>
                                <div class="col-sm-12">
                                     <div class="text-end">
                                        <button type="reset" class="btn btn-danger me-2" @click="discard()"><i class="ri-close-line icon_hgt"></i> DISCARD</button>
                                        <button type="submit" class="btn btn-primary" v-if="status"><i class="ri-save-line icon_hgt"></i> SUBMIT</button>
                                        <button type="submit" class="btn btn-primary" v-else><i class="ri-save-line icon_hgt"></i> UPDATE</button>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </form>
            </div>
            <div class="col-md-8">
                 <div class="d-flex align-items-center justify-content-between">
                    <label class="form-label">
                        <h4>Stages</h4>
                    </label>
                </div>
                <div class="card br-16 card-shadow">
                    <div class="card-body">
                        <div class="form-group mb-2 d-flex">
                            <input class="form-control form-control-sm" type="text" placeholder="Search" v-model="meta.search" @keypress.enter="search()" />
                        </div>
                        <div class="table-responsive table-responsive-sm">
                            <table class="table table-sm text-nowrap table-bordered mb-0">
                                <thead>
                                    <tr>
                                        <th class="text-center">#</th>
                                        <th @click="sort('stage')">
                                            Stage
                                            <span>
                                                <i v-if="meta.keyword=='stage' && meta.order_by=='asc'" class="ri-arrow-up-line"></i>
                                                <i v-else-if="meta.keyword=='stage' && meta.order_by=='desc'" class="ri-arrow-down-line"></i>
                                                <i v-else class="fas fa-sort"></i>
                                            </span>
                                        </th>
                                        <th>
                                            Admin Dashboard Visibility
                                        </th>
                                        <th>
                                            Mobile Dashboard Visibility
                                        </th>
                                        <th class="text-center">Status</th>
                                        <th class="text-center">Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-if="stages.length==0">
                                        <td colspan="6" class="text-center">No records found</td>
                                    </tr>
                                    <tr v-for="(stage,key) in stages" :key="key">
                                        <td class="text-center">{{meta.from+key}}</td>
                                        <td>{{stage.stage}}</td>
                                        <td>{{stage.admin_dashboard_visibility == true ? "Yes" : "No"}}</td>
                                        <td>{{stage.dashboard_visibility == true ? "Yes" : "No"}}</td>
                                        <td class="text-center">
                                            <div class="form-switch">
                                                <input class="form-check-input" type="checkbox" role="switch" :id="'stage' + stage.stage__id" :checked="stage.deleted_at ? 0 : 1" :value="stage.deleted_at ? 0 : 1" @change="deleteStage(stage)" />
                                                <label class="custom-control-label" :for="'stage' + stage.stage_id"></label>
                                            </div>
                                        </td>
                                        <td class="text-center">
                                            <nav v-if="!stage.deleted_at">
                                                <a href="javascript:void(0)" class="text-success me-2" @click.prevent="edit(stage)"><i class="ri-pencil-line icon_hgt"></i></a>
                                            </nav>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div class="mt-3">
                        <div class="d-flex justify-content-between align-items-center">
                            <select class="form-select from-select-sm width-75" v-model="meta.per_page" @change="onPerPageChange">
                                <option>10</option>
                                <option>15</option>
                                <option>20</option>
                                <option>25</option>
                                <option>30</option>
                            </select>
                            <span>Showing {{ meta.from }} to {{ meta.to }} of {{ meta.totalRows }} entries</span>

                            <Pagination :maxPage="meta.maxPage" :totalPages="meta.lastPage" :currentPage="meta.page" @pagechanged="onPageChange" />
                        </div>
                    </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Pagination from "@/components/Pagination.vue";
    export default {
        components: { Pagination },
        data() {
            return {
                meta: {
                    search: "",
                    order_by: "asc",
                    keyword: "stage_id",
                    per_page: 10,
                    totalRows: 0,
                    page: 1,
                    lastPage: 1,
                    from: 1,
                    to: 1,
                    maxPage: 1,
                    trashed: false,
                },
                status: true,
                stages: [],
                errors: [],
                stage: {
                    stage_id: "",
                    stage: "",
                    admin_dashboard_visibility:"",
                    dashboard_visibility:"",
                },
            };
        },
        mounted() {
            this.index();
        },
        methods: {
            search() {
                let vm = this;
                vm.meta.page = 1;
                vm.index();
            },
            index() {
                let vm = this;
                vm.$store
                    .dispatch("post", { uri: "stages/paginateStage", data: vm.meta })
                    .then(function (response) {
                        vm.stages = response.data.data.data;
                        // console.log('response.data.data:-----', response.data.data.meta.total)
                        vm.meta.totalRows = response.data.data.meta.total;
                        vm.meta.lastPage = response.data.data.meta.lastPage;
                        vm.meta.from = response.data.data.meta.from;
                        const end = vm.meta.from + Number(vm.meta.per_page) - 1;
                        vm.meta.to = end > vm.meta.totalRows ? vm.meta.totalRows : end;
                        vm.meta.maxPage = vm.meta.lastPage >= 3 ? 3 : vm.meta.lastPage;
                    })
                    .catch(function (error) {
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            },
            submitForm() {
                let vm = this;
                if (vm.status) {
                    vm.addStage();
                } else {
                    vm.updateStage();
                }
            },
            addStage() {
                let vm = this;
                let loader = vm.$loading.show();
                vm.$store
                    .dispatch("post", { uri: "stages/addStage", data: vm.stage })
                    .then(function () {
                        loader.hide();
                        vm.$store.dispatch("success", "Stage Added successfully");
                        vm.discard();
                        vm.errors = [];
                    })
                    .catch(function (error) {
                        loader.hide();
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            },
            edit(stage) {
                let vm = this;
                vm.$refs.stage.focus();
                vm.errors = [];
                vm.status = false;
                vm.stage = stage;
            },
            updateStage() {
                let vm = this;
                let loader = vm.$loading.show();
                let uri = { uri: "stages/updateStage", data: vm.stage };
                vm.$store
                    .dispatch("post", uri)
                    .then(function () {
                        loader.hide();
                        vm.$store.dispatch("success", "Stage is successfully updated");
                        vm.discard();
                        vm.errors = [];
                    })
                    .catch(function (error) {
                        loader.hide();
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            },
            discard() {
                let vm = this;
                vm.stage.stage = "";
                vm.$refs.stage.focus();
                vm.errors = [];
                vm.status = true;
                vm.stage.admin_dashboard_visibility = "";
                vm.stage.dashboard_visibility = "";
                vm.index();
            },

            deleteStage(stage) {
                let vm = this;
                let loader = vm.$loading.show();
                stage.status = stage.status == 1 ? 0 : 1;
                vm.$store
                    .dispatch("post", { uri: "stages/deleteStage", data: stage })
                    .then(function (response) {
                        loader.hide();
                        vm.$store.dispatch("success", response.data.message);
                        vm.discard();
                    })
                    .catch(function (error) {
                        loader.hide();
                        vm.errors = error.response.data.error;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            },

            onPageChange(page) {
                this.meta.page = page;
                this.index();
            },
            sort(field) {
                this.meta.keyword = field;
                this.meta.order_by = this.meta.order_by == "asc" ? "desc" : "asc";
                this.index();
            },
            onPerPageChange() {
                this.meta.page = 1;
                this.index();
            },
        },
    };
</script>
